import React from "react";
import { Button, Stack, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { v4 as uuidv4 } from "uuid";
import { useDispatch } from "react-redux";
import { vendorAdded } from "./vendorSlice";
import { createVendor } from "./httpCalls";

const schema = yup
  .object()
  .shape({
    companyName: yup.string().required("Name is Required"),
  })
  .required();

function AddVendor({ onClose }) {
  const companyCode = localStorage.getItem("companyCode");
  const dispatch = useDispatch();
  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const addNewVendor = async (values) => {
    let _id = uuidv4();
    let date = Date.now() / 1000;
    values._id = _id;
    values.date = date;
    values.company_code = companyCode;
    dispatch(vendorAdded(values));
    onClose();
    createVendor(values, dispatch);
    reset();
  };
  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h6" sx={{ color: "#4EAF51" }}>
        Add Items Brands Details
      </Typography>
      <TextField
        size="small"
        required
        autoFocus
        label="Company Name"
        fullWidth
        {...register("companyName")}
      />
      <Typography sx={{ color: "red" }}>
        {errors.companyName?.message}
      </Typography>
      <TextField
        size="small"
        label="Contact Or Department"
        type="text"
        fullWidth
        {...register("dept")}
      />
      <TextField
        size="small"
        label="Street Address"
        type="text"
        fullWidth
        {...register("street")}
      />
      <TextField
        size="small"
        label="City"
        type="text"
        fullWidth
        {...register("city")}
      />
      <TextField
        size="small"
        label="Phone"
        type="number"
        fullWidth
        {...register("phone")}
      />
      <Stack direction="row" justifyContent="center" spacing={3}>
        <Button variant="contained" onClick={handleSubmit(addNewVendor)}>
          Add Items Brands
        </Button>
        <Button variant="contained" onClick={onClose}>
          Cancel
        </Button>
      </Stack>
    </Stack>
  );
}

export default AddVendor;
